angular.module( 'acme.view.application.entities.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.modal',
  'acme.common.directive.fieldFocus',
  'acme.view.application.entities.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var entitiesList = {
        name: 'application.entities.list',
        url: '/list/:type',
        views: {
          "subview-main": {
            controller: 'EntitiesListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/entities/list/list.tpl.html'
          }
        },
        resolve: {
          preferenceKey: ['$stateParams', function($stateParams) {
            $stateParams._preferenceKey = $stateParams.type;

            return $stateParams._preferenceKey;
          }]
        },
        data: {
          pageTitle: '  ',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(entitiesList);
});
